import keycloak from './Keycloak';

export const GetToken = () => {
    //Attempt to get the token
    const token = keycloak?.token;
    if (!token) {
        //Logout and throw error
        keycloak.logout();
        throw new Error('Please login');
    }
    return token;
};
